export default __webpack_public_path__ + "static/media/cleanproReferralBanner.a6346560.jpg";